namespace $ {

	$mol_style_define( $bog_wikilive_tree, {

		flex: {
			grow: 1,
		},
		overflow: {
			y: 'auto',
			x: 'hidden',
		},

	} )

}
